export default async function GetVendorTerm(id) {
    let url = window.RealestateService+  `/api/Vendor/GetVendorTerm?VendorId=${id}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}